import { useAuth } from '@/features/auth';
import styles from './Header.module.css';

export function Header() {
  const { state, signIn, signOut } = useAuth();

  return (
    <header className={styles.header}>
      <div className={styles.wordmark}>
        hey<span>.sh</span>
      </div>
      <nav className={styles.nav}>
        <a href="#gallery">Modules</a>
        {state === 'authenticated' ? (
          <>
            <a href="/account">Account</a>
            <button onClick={signOut} type="button">
              Sign out
            </button>
          </>
        ) : (
          <button onClick={signIn} type="button">
            Sign in
          </button>
        )}
      </nav>
    </header>
  );
}
